var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFleet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.783,
    height: 17,
    viewBox: "0 0 14.783 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.913,4.457C5.646,4.457,3,4.826,3,7.413V14.8a2.2,2.2,0,0,0,.739,1.641v1.316a.741.741,0,0,0,.739.739h.739a.741.741,0,0,0,.739-.739v-.739H11.87v.739a.741.741,0,0,0,.739.739h.739a.741.741,0,0,0,.739-.739V16.445a2.2,2.2,0,0,0,.739-1.641V7.413c0-2.587-2.646-2.957-5.913-2.957M5.587,15.543A1.109,1.109,0,1,1,6.7,14.435a1.107,1.107,0,0,1-1.109,1.109m6.652,0a1.109,1.109,0,1,1,1.109-1.109,1.107,1.107,0,0,1-1.109,1.109m1.109-4.435H4.478v-3.7h8.87v3.7m4.435-6.652v7.391a2.2,2.2,0,0,1-.739,1.641V14.8a.741.741,0,0,1-.739.739h-.089A3.429,3.429,0,0,0,16.3,14.8V7.413c0-4.435-5.174-4.435-7.391-4.435A20.587,20.587,0,0,0,6.3,3.1C7.1,1.737,9.283,1.5,11.87,1.5,15.137,1.5,17.783,1.87,17.783,4.457Z",
    transform: "translate(-3 -1.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet);
export default __webpack_public_path__ + "static/media/Fleet.5f01563269d51ca019fe86d296ffa4e9.svg";
export { ForwardRef as ReactComponent };